import { Box, Card, CardContent, CircularProgress, Stack, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import LoginForm from "../../components/auth/LoginForm";
import OTPForm from "../../components/auth/OTPForm";
import SignupForm from "../../components/auth/SignUpForm";
import TermsConditions from "../../components/modals/terms_conditions";
import '../../global.css';
import { getMyWatchlist } from "../../helpers/fetchWatchlist";
import { saveUser } from "../../redux/reducers/userSlice";
import authServices from "../../services/authServices";
import logsService from "../../services/logServices";
import { InvestorActivityEventType } from "../../utils/eventTypes";
import { useParams } from "react-router-dom";   
import CookieStorage from '../../utils/cookieStorage';
export default function Login({ open, handleClose = () => { }, openSign = false, setShowSignUp = () => { }, showTerms, setShowTerms = () => { } }) {
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const { distributorCode, rm } = useParams()
    const referredBy = queryParams.get("referredBy")||sessionStorage.getItem("referredBy");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [otpForm, setOtpForm] = useState(false);
    const [signUp, setSignUp] = useState(false);
    const [number, setNumber] = useState("");
    const [inviteCode, setInviteCode] = useState("");
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const user = useSelector(state => state.user.data);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const from = location.state?.from || "/dashboard";
    useEffect(() => {
        if (openSign) {
            setSignUp(openSign);
        }
    }, [openSign])

    const handleSendOtp = async (token) => {
        if (!token) {
            enqueueSnackbar("Please verify you are not a robot", { variant: "error" })
            return;
        }
        const coupon = localStorage.getItem("coupon");
        const data = {
            mobileNumber: number,
            distributorCode: distributorCode || referredBy || "",
            rm: rm || "",
            coupon: coupon ? coupon : null,
            recaptchaValue: token
        }
        setLoading(true)
        try {
            
            const res = await authServices.sendOTP(data)
            if (res && res.success) {
                setOtpForm(true);
                enqueueSnackbar("OTP sent successfully", { variant: "success" })
                logsService.addLog({
                    mobileNumber: number,
                    event: InvestorActivityEventType.LOGIN
                })
            }
            else {
                enqueueSnackbar(res?.message || "Something went wrong!", { variant: "error" })
            }
        } catch (error) {
            enqueueSnackbar(error?.message || "Something went wronggg!", { variant: "error" })
        } finally {
            setLoading(false)
        }
    }

    const handleVerifyOtp = async () => {
        const data = {
            mobileNumber: parseInt(number),
            otp: otp
        }
        setLoading(true)
        const res = await authServices.verifyOTP(data);
        setLoading(false)
        if (res && res.success && res?.data?.length > 0) {
            CookieStorage.set("access", res.token.access.token, { path: '/', days: 7 });
            CookieStorage.set("refresh", res.token.refresh.token, { path: '/', days: 15 });
            const userWithUrl = {
                ...res.data[0],
                url: res.url,
            };
            dispatch(saveUser(userWithUrl));
            await getMyWatchlist(dispatch)
                logsService.addLog({
                userId: res.data[0]?._id,
                event: InvestorActivityEventType.VERIFY_LOGIN
                })
            if (res.data[0].conditionAccepted) {
                enqueueSnackbar("Logged in successfully", { variant: "success" })
                if(res.data[0]?.status === "FIRST_TIME" || res.data[0]?.status === "REGISTERED" || res.data[0]?.status === "KYC_APPROVED"){
                navigate(`/dashboard?show=${(res.data[0]?.status === "FIRST_TIME" || res.data[0]?.status === "REGISTERED" || res.data[0]?.status === "KYC_APPROVED")}`, { state: res.data[0]?.status });
                }else{
                    navigate(from, { state: res.data[0]?.status });
                }
            }
            else {
                setOtp(true);
                setIsModalOpen(true);
                onClose();
            }
        }
        else {
            enqueueSnackbar("OTP is incorrect", { variant: "error" })
        }
    }

    useEffect(() => {
        if (!otpForm) {
            setOtp("");
        }
    }, [otpForm])

    // useEffect(() => {
    //     if (!user?.conditionAccepted && CookieStorage.has('access')){
    //         setIsModalOpen(true)
    //     }
    // },[user])

    useEffect(() => {
        setNumber('')
        setInviteCode('')
        setOtp('')
    }, [signUp])

    const onClose = () => {
        setNumber("");
        // setOtp("");
        setOtpForm(false);
        handleClose();
        setTimeout(() => {
            setSignUp(false);
            setShowSignUp(false);
        }, 200)
    }

    const onCloseTerms = (value) => {
        setShowTerms(false);
        if (value) {
            enqueueSnackbar("Logged in successfully", { variant: "success" })
            navigate(`/dashboard?show=${(user?.status === "FIRST_TIME" || user?.status === "REGISTERED" || user?.status === "KYC_APPROVED")}`, { state: user?.status });
        }
        else {
            enqueueSnackbar("You cannot proceed without accepting buyer agreement.", { variant: "error" })
        }
    }

    return (
        <>
            {isModalOpen && <TermsConditions open={isModalOpen} setIsModalOpen={setIsModalOpen} handleClose={onCloseTerms} />}
            {/* <ModalComponent open={open} handleClose={onClose} title={otpForm?"Enter OTP":signUp?"Signup":"Login"} > */}
            <Card className="card login-wrapper" style={{ height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'start' }}>
                <Box position="relative">
                    {loading && (
                        <Box
                            sx={{
                                position: "absolute",
                                inset: 0,
                                zIndex: (theme) => theme.zIndex.modal + 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <CircularProgress
                                size={50}
                                thickness={3}
                            />
                        </Box>
                    )}
                    <CardContent style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "start" }}>
                        <Stack direction={"column"} alignItems={"center"} style={{ textAlign: "center" }}>
                            <img src="/assets/images/logo.png" className="login-page-logo" />
                        </Stack>
                        <Stack direction={"column"} alignItems={"center"}>
                            <Typography style={{ textAlign: "left", paddingTop: "15px" }} variant="aboutHeading3">{otpForm ? "Enter OTP" : signUp ? "Signup" : "Login/Signup"}</Typography>
                        </Stack>
                        {
                            !otpForm ?
                                signUp ?
                                    <SignupForm setSignUp={setSignUp} number={number} setNumber={setNumber} handleSendOtp={handleSendOtp} />
                                    :
                                    <LoginForm setSignUp={setSignUp} number={number} setNumber={setNumber} handleSendOtp={handleSendOtp} setLoading={setLoading} setOtp={setOtp} setShowTerms={setIsModalOpen} onClose={onClose} distributorCode={referredBy} />
                                :
                                <OTPForm otp={otp} setOtp={setOtp} number={number} setOtpForm={setOtpForm} handleVerifyOtp={handleVerifyOtp} handleSendOtp={handleSendOtp} />
                        }

                    </CardContent>
                    <Footer></Footer>

                </Box>
            </Card>

            {/* </ModalComponent> */}
        </>
    )
}


function Footer() {
    return (
        <footer style={{ color: "#333333", textAlign: "center" }}>
            <Typography variant="body2"> Copyright &copy;
                <a variant="body2" style={{ textDecoration: "none" }} href="https://realx.in"> RealX {new Date().getFullYear()}</a></Typography>      </footer>
    );
}
